import { getWindow } from 'src/utilities/window';
import { isServerSide } from 'src/utilities/isServerSide';

export enum MediaTypes {
  APPLICATION_JSON = 'application/json;',
  APPLICATION_PDF = 'application/pdf;',
  APPLICATION_ZIP = 'application/zip;',
  APPLICATION_ZIP_IE = 'application/x-zip-compressed;',
  TEXT_CSV = 'text/csv;charset=utf-8;',
}

// This is a workaround for IE11, which for some reason is not recognized by newer versions of typescript
type IEWindowNavigator = typeof window.navigator & {
  msSaveBlob: (blob: Blob, filename: string) => void;
  msSaveOrOpenBlob: (blob: Blob, filename: string) => void;
};

export function saveFile(
  data: string | ArrayBuffer,
  filename: string,
  mimeType: MediaTypes
): void {
  if (!isServerSide()) {
    const window = getWindow();
    const blob = new Blob([data], {
      type: mimeType,
    });

    if ((window.navigator as IEWindowNavigator).msSaveOrOpenBlob) {
      // for IE
      (window.navigator as IEWindowNavigator).msSaveBlob(blob, filename);
    } else {
      // for Non-IE (chrome, firefox etc.)
      const downloadLink = window.document.createElement('a');
      downloadLink.href = window.URL.createObjectURL(blob);
      downloadLink.download = filename;
      downloadLink.style.display = 'none';
      window.document.body.appendChild(downloadLink);
      downloadLink.click();
      window.document.body.removeChild(downloadLink);
    }
  }
}
